import React from 'react'

import { F0Checkbox } from '@factorialco/f0-react'

import { Element } from 'modules/forms/lib/Element'
import { Answer } from 'modules/forms/lib/types'

interface CheckboxElementQuestionProps {
  element: Element
  onChange?: (answer: Answer) => void
  disabled?: boolean
}

const CheckboxElementQuestion: React.FC<CheckboxElementQuestionProps> = ({
  element,
  onChange,
  disabled,
}) => {
  const currentValue = element.answer?.answer === 'true'
  const [checked, setChecked] = React.useState(currentValue)

  React.useEffect(() => {
    setChecked(element.answer?.answer === 'true')
  }, [element.id, element.answer?.answer])

  const handleOnChange = (newChecked: boolean) => {
    setChecked(newChecked)
    onChange?.({ answer: newChecked ? 'true' : '' })
  }

  return (
    <F0Checkbox
      title={element.label}
      checked={checked}
      onCheckedChange={handleOnChange}
      disabled={disabled}
      required={element.mandatory}
    />
  )
}

export default CheckboxElementQuestion
